export default __webpack_public_path__ + "static/flex_tile-52f842b21c9275bdb3e9fa8b7bcc6430.jpg";